import React from 'react';
import {Trans} from 'react-i18next';
import {CONSTANTS} from '../../../../../../Shared/Constants/Constants';

type SensorBasicsCustomersIdProps = {
	show: boolean;
	customerId: string;
};

export default function SensorBasicsCustomersIdComponent(props: SensorBasicsCustomersIdProps) {
	return (
		props.show && (
			<tr>
				<td>
					<Trans i18nKey={'sensorWizard.summary.customersID'} />
				</td>
				<td>{props.customerId ? props.customerId : CONSTANTS.NOT_AVAILABLE}</td>
			</tr>
		)
	);
}
